import React, { useEffect, useRef, useState } from "react";
import "../supplierAndManufacturers.scss";
import { CategoryOrSubcategoryItem, getColorHex } from "./TableBody";
import { Dropdown } from "react-bootstrap";
import { HGHighlightText } from "../../../App/App";

const CategoryOrSubcategoryDropdown = ({
  selectedData = [],
  data = [],
  isError = false,
  onItemClick = (item) => { },
  onCross = (item) => { },
}) => {
  const [searchString, setSearchString] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isDropdownOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isDropdownOpen]);

  return (
    <div className="w-100">
      <Dropdown className="service-type-dropdown w-100" show={isDropdownOpen} onToggle={(isOpen) => setIsDropdownOpen(isOpen)}>
        <Dropdown.Toggle className="w-100">
          <div className={`d-flex flex-wrap highlight-tags-input-with-grey-border w-100 align-items-center p-2 radius-4 mt-1 ${isError ? 'input-error' : ''}`}>
            {selectedData?.map((item, index) => (
              <CategoryOrSubcategoryItem
                key={item?.ObjectId || index}
                name={item?.Name}
                color={item?.Icon}
                isLast={index + 1 === selectedData?.length}
                onCrossClick={() => onCross(item)}
              />
            ))}
            <input
              ref={inputRef}
              tabIndex={0}
              type="text"
              placeholder=""
              className="flex-grow-1 px-2"
              value={searchString}
              onChange={(e) => { setSearchString(e.target.value) }}
            />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu renderOnMount className="w-100 mt-1">
          {
            data?.filter((filterItem) => filterItem?.CategoryName?.toLowerCase().includes(searchString?.toLowerCase()))?.length > 0 ? <div>
              {
                data?.filter((filterItem) => filterItem?.CategoryName?.toLowerCase().includes(searchString?.toLowerCase()))?.map((dataItem) => {
                  let isSelected = selectedData?.some(item => item?.ObjectId === dataItem?.ObjectId);
                  return (
                    <DropdownItem
                      key={dataItem?.ObjectId}
                      name={dataItem?.CategoryName}
                      color={dataItem?.CategoryColour}
                      isSelected={isSelected}
                      search={searchString}
                      onClick={(e) => {
                        onItemClick(dataItem);
                        setIsDropdownOpen(false);
                      }}
                    />
                  );
                })}
            </div> : <div className="d-flex align-items-center justify-content-center my-5 f-400 f-12 f-darkgrey line-height-22 letter-space-2 w-100">
              No data to select
            </div>
          }
        </Dropdown.Menu>
      </Dropdown>
      {isError && <div className="f-danger f-12">Field cannot be empty</div>}
    </div>
  );
};

export default CategoryOrSubcategoryDropdown;

const DropdownItem = ({
  name = '',
  color = '',
  isSelected = false,
  search = '',
  onClick = () => { }
}) => (
  <div className={`d-flex px-2 py-1 align-items-center pointer bg-hover-grey ${isSelected && 'bg-grey-imp'}`} onClick={onClick}>
    {isSelected ? <img alt="" src="/images/msp/dropdown-grey-tick.svg" /> : <div style={{ width: '12px' }}></div>}
    <div style={{ width: "8px", height: "8px", background: getColorHex(color) }} alt="" className="mx-2 rounded-full" />
    <div>
      <span dangerouslySetInnerHTML={{ __html: HGHighlightText(name, search) }} />
    </div>
  </div>
)